import { ItiString } from "@/iti-core-react/utils/iti-string";
import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
	heritageColumn: {
		datasetName: ItiString.Empty,
		artifacttName: ItiString.Empty,
	},
};

const artifactColumnSlice = createSlice({
	name: "heritageColumn",
	initialState,
	reducers: {
		heritageColumn(state, action) {
			state.heritageColumn = {
				...state.heritageColumn,
				...action.payload,
			};
		},
	},
});

export default artifactColumnSlice;
